import React from "react";
import { Icon, StackProps, Text, VStack } from "@chakra-ui/react";
import useTranslate from "hooks/useTranslate";
import BearSadIcon from "components/BearSadIcon";

export interface EmptyStateProps extends StackProps {
  label?: React.ReactNode;
}

const EmptyState: React.FC<EmptyStateProps> = ({ label, ...rest }) => {
  const translate = useTranslate();

  return (
    <VStack align="center" spacing="3" {...rest} textAlign="center">
      <Icon as={BearSadIcon} w="10" h="auto" />
      <Text fontSize="sm" maxW="28" lineHeight="short">
        {label || translate("common:noResults")}
      </Text>
    </VStack>
  );
};

export default EmptyState;
